export const PARAMS_TO_IGNORE = 
    [
        "EQ Frequency 1 gain",
        "type",
        "EQ Frequency 5 gain",
        "EQ Frequency 8 gain",
        "Pulse Width",
        "algorithm",
        "Chop",
        "Velocity",
        "Slice",
        "Chop Duration",
        "Duration",
        "Transpose",
        "width",
        "speed",
        "Configuration",
        "Feedback",
        "list",
        "Drive",
        "enabled",
        "parametersDisabled",
        "Enabled",
        "blur",
        "pitchBend",
        "Polyphony",
        "phase",
        "stages",
        "smoothness",
        "Custom Oscillator Type",
        "lengthFactor",
        "Curve",
        "Release Curve",
        "Decay Curve",
        "Attack Curve",
        "triplet1",
        "triplet2",
        "triplet3",
        "triplet4",
        "triplet5",
        "triplet6",
        "scale1",
        "scale2",
        "scale3",
        "scale4",
        "scale5",
        "scale6",
        "rule1",
        "rule2",
        "rule3",
        "rule4",
        "rule5",
        "rule6",
        "Oscillator Type",
        "resolution",
        //"Harmonics",
        "rolloff",
        "Level",
        "curve",
        "Filter Cutoff (hi-pass)",
        "Filter Q (hi-pass)",
        // "Partials",
        "Partial Count",
        "LFO Type", // todo: mmake this an OptionParameter so that it can be sent
    ];

export const PARAMS_TO_LOWER_DEPTH = [
    "detune",
    "harmonicity",
    "feedback",
    "modulationindex"
];

export const PARAMS_TO_NOT_MODULATE = [
    "Sustain",
    "Partials",
    "Harmonics",
    "steps",
    "Resolution",
    "Probability",
    "Rate",
    "lengthFactor",
    "resolution",
    "probability",
    "Decay",
    "Attack",
    "Release"
];


export const getTrackParameters = (device, effect) => {
    let parameters = device.getAllParameters ? device.getAllParameters(false) :
        device.getParameters ? device.getParameters() : device.parameters;
    
    return parameters
        .filter(x => x.automatable && !x.config.isDb)
        .filter(x => !x.hasMacro)
        .filter(x => !x.isMapped)
        .filter(
            x => !PARAMS_TO_IGNORE.includes(x.name));
};

